import React from 'react';
import './footer.scss';

import { Link } from 'react-router-dom';
import { useGetCms } from '../../views/home/api/api';
import { useICOStatus } from '../../views/modals/api/api';

export const Footer = () => {

    const getyear = new Date().getFullYear();
    const { data: getCms } = useGetCms()
    const {data:siteSettings}=useICOStatus()

    return (
        <footer className='footer'>
            <div className="container">
                <div className='footerbg'>
                    <div className="row">
                        <div className="col-lg-6 col-md-12 col-sm-12 order-1 order-lg-2">
                            <div className='logo mb-2 text-center'>
                                <img src={require('../../assets/images/footer/footerlogo.png')} alt='footerlogo' />
                            </div>
                            <div className='footerpara text-center px-md-5 mb-3'>
                                <div dangerouslySetInnerHTML={{ __html: getCms?.data[4]?.content }} />
                            </div>
                            <div className='d-none d-lg-block'>
                                <div className='SocialMediaList '>
                                    <ul>
                                        <li><Link to={siteSettings?.data?.facebookUrl} target="_blank"><img src={require('../../assets/images/footer/fb.svg').default} alt='scIcon' className='img-fluid' /></Link></li>
                                        <li><Link to={siteSettings?.data?.telegramUrl} target="_blank"><img src={require('../../assets/images/footer/whatsapp.svg').default} alt='scIcon' className='img-fluid' /></Link></li>
                                        <li><Link to={siteSettings?.data?.xUrl} target="_blank"><img src={require('../../assets/images/footer/x.svg').default} alt='scIcon' className='img-fluid' /></Link></li>
                                        <li><Link to={siteSettings?.data?.linkedinUrl} target="_blank"><img src={require('../../assets/images/footer/youTube.svg').default} alt='scIcon' className='img-fluid' /></Link></li>
                                        <li><Link to={siteSettings?.data?.instagramUrl} target="_blank"><img src={require('../../assets/images/footer/insta.svg').default} alt='scIcon' className='img-fluid' /></Link></li>
                                    </ul>
                                </div>
                                <div className='secondfooter text-center'>
                                    Copyright © {getyear} the pill  – All Rights Reserved V1.1
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-5 order-2 order-lg-1">
                            <div className="footerListTitle">Quick Links</div>
                            <div>
                                <ul className="footerList">
                                    <li><Link to="/">About Us</Link></li>
                                    <li><Link to="/">Terms and Conditions</Link></li>
                                    <li><Link to="/privacypolicy">Privacy Policy</Link></li>
                                    <li><Link to="/faq">FAQ</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-6 order-3 order-lg-3 pl-lg-5">
                            <div className="footerListTitle">Contact Us</div>
                            <div>
                                <ul className="footerList">
                                    <li><Link to="mailto:info@pill.com">info@pill.com</Link></li>
                                </ul>
                            </div>
                            <div className='d-lg-none mt-3'>
                                <div className='SocialMediaList '>
                                    <ul>
                                        <li><Link to={siteSettings?.data?.facebookUrl} target="_blank"><img src={require('../../assets/images/footer/fb.svg').default} alt='scIcon' className='img-fluid' /></Link></li>
                                        <li><Link to={siteSettings?.data?.telegramUrl} target="_blank"><img src={require('../../assets/images/footer/whatsapp.svg').default} alt='scIcon' className='img-fluid' /></Link></li>
                                        <li><Link to={siteSettings?.data?.xUrl} target="_blank"><img src={require('../../assets/images/footer/x.svg').default} alt='scIcon' className='img-fluid' /></Link></li>
                                        <li><Link to={siteSettings?.data?.linkedinUrl} target="_blank"><img src={require('../../assets/images/footer/youTube.svg').default} alt='scIcon' className='img-fluid' /></Link></li>
                                        <li><Link to={siteSettings?.data?.instagramUrl} target="_blank"><img src={require('../../assets/images/footer/insta.svg').default} alt='scIcon' className='img-fluid' /></Link></li>
                                    </ul>
                                </div>
                                <div className='secondfooter text-center'>
                                    Copyright © {getyear} the pill  – All Rights Reserved V1.1
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </footer>
    )
}
